// extracted by mini-css-extract-plugin
module.exports = {"scene":"Scene_scene__3qFsF"};